module.exports = __webpack_public_path__ + "img/1fb4faac86b8ff00819f55b0dbf5029e.1fb4faac.png";